import React, { useEffect } from "react";
import { Route, Routes, Navigate, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import {
  authRoutes,
  publicRoutes,
} from "../backendComponents/admin/router.link";
import {
  authWebsiteRoutes,
  publicWebsiteRoutes,
} from "../backendComponents/website/router.link";
import Feature from "../../layouts/feature";
import Login from "../../authentication/backendModule/admin/login";
import PrivateRoute from "../../authentication/backendModule/admin/privateAuth";
import apiRequestCall from "../../apiHelper/globalHelper";
import { all_routes } from "./admin/all_routes";

const isAuthenticated = (): boolean => !!localStorage.getItem("authToken");

const ALLRoutes: React.FC = () => {
  const { pathname } = useLocation();
  const isWebsite = pathname.startsWith("/website-dashboard");

  const currentRoute = { title: "Cromatography World" };
  const fullTitle = `${currentRoute.title} | CRMS - Customer Order Management`;
  const backendRoute = all_routes.backend;

  useEffect(() => {
    document.title = fullTitle;
  }, [fullTitle]);

  // useEffect(() => {
  //   const logoutUser = async () => {
  //     const token = localStorage.getItem("authToken");

  //     if (token) {
  //       try {
  //         const result = await apiRequestCall("post", backendRoute["logout"]);

  //         if (result?.data?.code === 200) {
  //           localStorage.removeItem("authToken");
  //         } else {
  //           console.error("Failed to logout");
  //         }
  //       } catch (err) {
  //         console.error("Logout error:", err);
  //       }
  //     }
  //   };

  //   window.addEventListener("beforeunload", logoutUser);
  //   window.addEventListener("unload", logoutUser);

  //   return () => {
  //     window.removeEventListener("beforeunload", logoutUser);
  //     window.removeEventListener("unload", logoutUser);
  //   };
  // }, []);

  /* --------------- WEBSITE (both public + protected wrapped) --------------- */
  if (isWebsite) {
    return (
      <>
        <Helmet>
          <title>{fullTitle}</title>
        </Helmet>

        <Routes>
          {/* both publicWebsiteRoutes and authWebsiteRoutes live under the same wrapper */}
          <Route element={<PrivateRoute />}>
            <Route element={<Feature />}>
              {/* {publicWebsiteRoutes.map((route, idx) => (
                <Route
                  path={route.path}
                  element={route.element}
                  key={`wpub-${idx}`}
                />
              ))} */}
              {authWebsiteRoutes.map((route, idx) => (
                <Route
                  path={route.path}
                  element={route.element}
                  key={`wauth-${idx}`}
                />
              ))}
            </Route>
          </Route>

          {/* website fallback: if logged-in redirect to website home else to website login */}
          <Route
            path="*"
            element={
              isAuthenticated() ? (
                <Navigate to="/website-dashboard" replace />
              ) : (
                <Navigate to="/website-dashboard/login" replace />
              )
            }
          />
        </Routes>
      </>
    );
  }

  /* --------------------- ADMIN (default) --------------------- */
  return (
    <>
      <Helmet>
        <title>{fullTitle}</title>
      </Helmet>

      <Routes>
        {/* public admin route */}
        <Route path="/login" element={<Login />} />

        {/* protected admin with same wrapper */}
        <Route element={<PrivateRoute />}>
          <Route element={<Feature />}>
            {publicRoutes.map((route, idx) => (
              <Route
                path={route.path}
                element={route.element}
                key={`ap-${idx}`}
              />
            ))}
            {authRoutes.map((route, idx) => (
              <Route
                path={route.path}
                element={route.element}
                key={`aa-${idx}`}
              />
            ))}
          </Route>
        </Route>

        {/* fallback */}
        <Route
          path="*"
          element={
            isAuthenticated() ? (
              <Navigate to="/404" replace />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
      </Routes>
    </>
  );
};

export default ALLRoutes;
